export default class dataprivacyAnchor{
  
  constructor() {  
    $(function(){
	
   if (window.location.href.indexOf("info") > -1)
		{
		
		if (($(window).width() <= 375) && ($(window).width() >340 ))  {

		$(window).scrollTop(2280);
			}
		if ($(window).width() <= 340) {

		$(window).scrollTop(2690);
			}
		if (($(window).width() < 768) && ($(window).width() >375 )) 
		{  
		$(window).scrollTop(2085);
		}
		if (($(window).width() <= 1024) && ($(window).width() >= 768))
		{
		$(window).scrollTop(1140);
		}
		if ($(window).width() > 1024) {
		$(window).scrollTop(1000);
		}
		}
		});

    }
	
  }




  